import request from '../../../helpers/request';

const changeTransport = async (values, { id }) => {
  const response = await request.put(
    `/HousingStock/transport/${id}`,
    values,
    `При изменении транспорта произошла ошибка`
  )

  return response
}

export default changeTransport